const isAfterDob = (inputValue, allValues) => {
	if (!inputValue || !allValues.personalInformation.dob) {
		return undefined;
	}

	const valueArr = inputValue.split('-');
	// Subtract 1 from month because months in Date objects are 0-based
	const valueDate = new Date(valueArr[0], valueArr[1] - 1, valueArr[2]);
	// Without setFullYear, the Date constructor assumes any 2-digit years are in the 1900s.
	valueDate.setFullYear(valueArr[0]);

	const dobArr = allValues.personalInformation.dob.split('-');
	const dobDate = new Date(dobArr[0], dobArr[1] - 1, dobArr[2]);
	dobDate.setFullYear(dobArr[0]);

	if (valueDate < dobDate) {
		return `Cannot be before date of birth - ${dobDate.toLocaleDateString()}`;
	}

	return undefined;
};

export default isAfterDob;
